export function returnReject(error) {

    const body = error && error.body ? error.body : {};
    const response = error && error.response ? error.response : null;
    const responseData = response && response.data ? response.data : {};
    const status = error && error.status ? error.status : response && response.status ? response.status : 0;
    const statusText = error && error.statusText ? error.statusText : response && response.statusText ? response.statusText : '';
    const message = body.message || responseData.message || error && error.message || 'Ocorreu um erro ao processar a solicitacao.';
    const code = body.code || responseData.code || status;
    const errors = body.errors || responseData.errors || {};

    if(status === 422) {

        const params = {
            success:    body.success === undefined ? false : body.success,
            code:       code,
            errors:     errors,
            message:    message
        };

        return params;

    } else {

        const params = {
            success:    false,
            code:       code,
            message:    message,
            error:      statusText,
            errors:     errors
        }

        return params;

    }

}

export function returnResolve(data) {

    const items = {
        success:    data.body.success,
        data:       data.body.data,
        message:    data.body.message,
        totalCount: data.body.totalCount ? data.body.totalCount : 0,
    }

    //Para caso exista paginação
    if(typeof data.body.meta !== undefined) {
        
        const body = data.body;
        
        items.meta = {
            page:           body.meta ? body.meta.current_page          : body.current_page ? body.current_page : 1,
            itemsPerPage:   body.meta ? parseInt(body.meta.per_page)    : body.per_page     ? body.per_page     : 1,
            total:          body.meta ? body.meta.total                 : body.total        ? body.total        : 1,
            last_page:      body.meta ? body.meta.last_page             : body.last_page    ? body.last_page    : 0,
            // Subtotais agregados do conjunto filtrado (quando o endpoint enviar).
            totals:         body.meta ? body.meta.totals : undefined,
        };
    }

    if(data.body.skipped_sheets) {
        items.skipped_sheets = data.body.skipped_sheets;
    }

    return items
}